import React from 'react'
import styles from './casher.css'

function Casher() {
  return (
    <div>casher</div>
  )
}

export default Casher